import React, { PropTypes } from 'react';
import { FontIcon, Paper } from 'material-ui';
import { call, compose, map, keys, concat, reject, contains, __, last, isEmpty } from 'ramda';
import { css, StyleSheet } from 'aphrodite';
import SortableList from '../../tc-ui/sortable-list-with-react-dnd/sortable-list';
import DraggableCard from '../../tc-ui/sortable-list-with-react-dnd/draggable-card';
const border = '1px dashed rgba(0, 0, 0, 0.54)';
import { extraNameAndCode } from '../../../utils/contracting-preset-names-codes';
import Select from 'react-select';
const styles = StyleSheet.create({
  header: { backgroundColor: '#f5f5f5', padding: '0 16px', lineHeight: '48px', color: 'black', fontSize: '20px' },
  listContainer: { display: 'flex', width: '100%', marginTop: '16px' },
  draggableCard: { margin: '0px 0px 8px 32px', width: '90%' },
  sortableItem: { border, padding: '12px 6px' },
  selectFieldStyle: { width: '80%', marginLeft: '32px' },
  text: { display: 'inline-block', width: '80%', marginLeft: '6px', position: 'relative', top: '-2px', cursor: 'pointer' },
});

const ExtraLine = ({ selectedExtras, otherSelectedExtras, updateLine, lineNo, removeAnExtraFromAnotherLine }) => {
  const fullExtraNamesOptions = call(compose(
    map(name => ({ label: name, value: name })),
    concat(__, otherSelectedExtras),
    reject(contains(__, otherSelectedExtras)),
    keys
  ), extraNameAndCode);
  return (
    <Paper style={{ marginTop: '24px', minHeight: '200px', paddingBottom: '32px' }}>
      <div className={css(styles.header)}>Extra Line {lineNo}</div>
      <br />
      <div className={css(styles.selectFieldStyle)}>
        <Select
          multi
          simpleValue
          options={fullExtraNamesOptions}
          value={selectedExtras.join(',')}
          placeholder="Select extra(s) to export"
          onChange={values => {
            const valAsArray = values ? values.split(',') : [];
            const currentValue = last(valAsArray);
            if (contains(currentValue, otherSelectedExtras)) {
              const confirmed = confirm(`You have selected this extra for another line, do you want to move it to Extra Line ${lineNo}?`);
              if (confirmed) {
                removeAnExtraFromAnotherLine(currentValue);
                updateLine({ selectedExtras: valAsArray });
              }
            } else updateLine({ selectedExtras: valAsArray });
          }}
        />
      </div>
      <div style={{ display: !isEmpty(selectedExtras) ? 'block' : 'none', margin: '24px 0px 0px 32px', width: '80%' }}>
        <div style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.68)' }}>Prioritize extra(s) to export</div>
        <i>If an extra is not present in TourConnect, we will attempt to export the next available extra in your list until there are no available options to export.</i>
      </div>
      <div className={css(styles.listContainer)}>
        <SortableList
          style={{ width: '45%', display: 'inline-block' }}
          arrayOfData={selectedExtras}
          dragEnds={vals => updateLine({ selectedExtras: vals })}
        >
          {
            selectedExtras.map((item, i) => (
              <DraggableCard key={i} className={css(styles.draggableCard)} isDragSource isDropTarget>
                <div className={css(styles.sortableItem)}>
                  <div className={css(styles.text)}>{item}</div>
                  <FontIcon className="tc-icon-swap_vert" style={{ color: 'rgba(0, 0, 0, 0.34)', top: '5px' }}/>
                </div>
              </DraggableCard>))
          }
        </SortableList>
        <div style={{ display: 'inline-block', width: '5%' }}>
          {
            selectedExtras.map((_, i) => i ? (
              <div style={{ textAlign: 'center', height: '65px' }} key={i}>
                <span style={{ top: '45px', position: 'relative' }}>OR</span>
              </div>
            ) : <div key={i}/>)
          }
        </div>
      </div>
    </Paper>
  );
};

export default ExtraLine;



// WEBPACK FOOTER //
// ./src/app/components/integration/settings/extra-line.jsx